(function() {

    'use strict';

    var equivalenceMobileCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'equivalence-mobile.component.html',
        controller: equivalenceMobileCtrl,
        bindings: {
            data: '<',
            translations: '<',
            centimeter: '<',
            sectionActive: '<',
            goToMeasureMyself: '&'
        }
    };

    // equivalenceMobileCtrl.$inject = [];

    function equivalenceMobileCtrl() {

        var _this = this;

        _this.toggleUnitOfmeasure = toggleUnitOfmeasure;
        _this.textPagination = setTextPagination();
        _this.highlightedCountry = highlightedCountry;
        _this.showInchesText = _this.centimeter;

        var arraySwiper = {
            sizes: {},
            equivalences: {}
        };
        var keyObjEq = 'equivalence';
        var keyObjSize = 'size';
        
        function Options(className){
            this.speed = 400;
            this.loop = false;
            this.autoplay = false;
            this.activeIndex = true;
            this.pagination = {
                el: '.swiper-pagination-' + className,
                type: 'bullets',
                clickable: true
            };
            return this;
        }
        
        _this.tablet = false;
        // _this.tablet = ItxScreenSizeSvc.is('sm');
        var columnsSizes = 2;
        // if(_this.tablet){
        //     columnsSizes = 3;
        // }
        
        // arrayPositionsSizes Dinámico
        $.each(this.data, function(key, value) {
            var number,array = [];
            if(value.subcategories){
                number = getNumberOfPositions(value.subcategories[0].sizes.length);
            }
            if(value.categories){
                number = getNumberOfPositions(value.categories[0].size.length);
            }
            for (var o = 0; o < number; o++) {
                array.push(o*columnsSizes);
            }
            value.arrayPositionsSizes = array;
        }); 

        _this.activeTab = _this.sectionActive;
        _this.clickTab = function(name){
            if(_this.activeTab == name){
                _this.activeTab = '';    
            } else {
                _this.activeTab = name;
            }
        };
        _this.isActiveTab = function(name){
            return _this.activeTab === name;
        };

        setTimeout(function() {
            for (var x = 0; x < _this.data.length; x++) {
                var obj = _this.data[x];
                if(obj.categories) {
                    for (var y = 0; y < obj.categories.length; y++) {
                        if(obj.categories[y].size){
                            var swiperSize = 'swiper-' + obj.categories[y].key_title + '-' + keyObjSize;
                            arraySwiper.sizes[swiperSize] = new Swiper('.' + swiperSize, new Options(obj.categories[y].key_title + '-' + keyObjSize));
                        }
                        if(obj.categories[y].equivalence){
                            var swiperEq = 'swiper-' + obj.categories[y].key_title + '-' + keyObjEq;
                            arraySwiper.equivalences[swiperEq] = new Swiper('.' + swiperEq, new Options(obj.categories[y].key_title + '-' + keyObjEq));
                        }
                    }
                }
                if(obj.subcategories) {
                    var name = obj.category + '-' + keyObjSize;
                    var swiperSizeAcc = 'swiper-' + name;
                    arraySwiper.sizes[swiperSizeAcc] = new Swiper('.' + swiperSizeAcc, new Options(name));
                }
            }
          
            $.each(arraySwiper.sizes, function(key, slide) {
                slide.on('transitionStart', function () { 
                    var keyArrayEquivalence = key.replace(keyObjSize, keyObjEq);
                    if(arraySwiper.equivalences[keyArrayEquivalence]){
                        arraySwiper.equivalences[keyArrayEquivalence].slideTo(slide.activeIndex);
                    }
                });  
            });  

            $.each(arraySwiper.equivalences, function(key, slide) {
                slide.on('transitionStart', function () {
                    var keyArraySizes = key.replace(keyObjEq, keyObjSize); 
                    if(arraySwiper.sizes[keyArraySizes]){
                        arraySwiper.sizes[keyArraySizes].slideTo(slide.activeIndex);
                    }
                });  
            }); 
       
        }, 200);    
       
        // SERVICE FUNCTIONS
        function setTextPagination() {
            var arrayName = [];
            _.each(_this.data, function (data) {
                arrayName.push( _this.translations[data.title + '_nav'] );
            });
            return arrayName;
        }

        function toggleUnitOfmeasure(measure) {
            if(measure === 'cm'){
                _this.centimeter = true;    
            } else {
                _this.centimeter = false;
            }
        }

        function highlightedCountry(key) {
            var arrayNotEurope = ['gb','us','me','cn','it','ko','ru'];
            if(key == 'eu' && arrayNotEurope.indexOf(inditex.iCountryCode.toLowerCase()) == -1) {
                return 'highlighted';
            } else if(key == inditex.iCountryCode.toLowerCase()) {
                return 'highlighted';
            }
        }
        
        function getNumberOfPositions(number){
            if((number % 2 === 0)){
                number = number / 2;
            } else {
                number++;
                number = number / 2;
            }
            return number;
        }

    }

    angular.module('itxApp.common')
        .component('equivalenceMobile', equivalenceMobileCmp);

})();